/**
 * auth接口配置
 */
import type { ApiEndpoint } from '../types';
import { API_CATEGORIES } from '../constants';

export const authEndpoints: ApiEndpoint[] = [
  {
    id: 'auth-verify',
    method: 'POST',
    path: '/api/auth/verify',
    name: '验证Token',
    description: '验证JWT Token是否有效',
    category: API_CATEGORIES.AUTH,
    bodyParams: [
      { name: 'token', type: 'string', required: true, description: 'JWT Token' }
    ],
    responseFields: [
      { name: 'success', type: 'boolean', description: '请求是否成功' },
      { name: 'data.valid', type: 'boolean', description: 'Token是否有效' },
      { name: 'data.admin', type: 'object', description: '管理员信息' }
    ],
    responseExample: JSON.stringify({
      success: true,
      data: {
        valid: true,
        admin: {
          id: "admin-id",
          username: "admin",
          email: "admin@example.com"
        }
      },
      message: "Token验证成功"
    }, null, 2)
  },
];
